module.exports = __webpack_public_path__ + "img/karow_short.43982b79.svg";